import axios from "@/util/axios";

const PREFIX_URI = "/basedata/product/serial";

export default {
    /** 分页查询序列号列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 按商品查询序列号 */
    queryByProduct: (productId) => axios.get({url: `${PREFIX_URI}/queryByProduct`, data: {productId}}),
    /** 保存序列号 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除序列号 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
}
